function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 18.688c3.563 0 10.688 1.75 10.688 5.313v2.688H9.313v-2.688c0-3.563 7.125-5.313 10.688-5.313zM8 13.313h4v2.688H8v4H5.312v-4h-4v-2.688h4v-4H8v4zM20 16c-2.938 0-5.313-2.375-5.313-5.313S17.062 5.312 20 5.312s5.313 2.438 5.313 5.375S22.938 16 20 16z"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), _ref);
};

export default SvgLink;